import React,{useState} from "react";

import './ExpenseForm.css'

const ExpenseForm =(props)=>
{
const [enterTitle,setEnterTitle]=useState('');
const [enterAmount,setEnterAmount]=useState('');
const [enterDate,setEnterDate]=useState('');

const titlechangeHandler=(event)=>{
        setEnterTitle(event.target.value);
    }
    const amountchangeHandler=(event)=>{
        setEnterAmount(event.target.value);
    }
    const datechangeHandler=(event)=>{
        setEnterDate(event.target.value);
    }

    const submitHandler=(event)=>
    {
       event.preventDefault();

       const expenseData={
        title:enterTitle,
        amount:enterAmount,
        date:new Date(enterDate)
       }
        props.onSaveExpense(expenseData);
       console.log(expenseData);

       setEnterTitle('');
       setEnterAmount('');
       setEnterDate('');
    }
    return(
        <form onSubmit={ submitHandler}>
          <div className='new-expense__controls'>
            <div className="new-expense__control">
                <label>Title</label>
                <input Type="text" value={enterTitle} onChange={titlechangeHandler}/>
            </div>
            <div className="new-expense__control">
                <label>amount</label>
                <input Type="number"value={enterAmount} min="0.01" step="0.01" onChange={amountchangeHandler}/>
            </div>
            <div className="new-expense__control">
                <label>Date</label>
                <input Type="date" value={enterDate} onChange={datechangeHandler}/>
            </div>
          </div>
          <div className="new-expense__actions">
            <button type="submit">Add Expense</button>
          </div>
        </form>
    );
}

export default ExpenseForm;